<!-- FeatureConditional.vue -->
<!--    
    Main use: Default slot is used to display content when a feature is enabled.  
    Secondary use: The 'featureDisabled' is rendered when the feature is NOT enabled.
        NOTE: If we don't know if the feature is enabled or not, we render nothing. 
-->
<script lang="ts" setup>
import { onBeforeMount, reactive } from 'vue';
import { FeatureType } from '../../Enums/ChoiceEnums';
import { DisplayStyle } from '../../Enums/UiEnums';
import { initPinia } from '../../lib/PiniaMgr';
import { useCompanySettingsStore } from '../../lib/Stores/CompanySettingsStore';
import MessageText from '../../components/Messages/MessageText.vue';

    const props = defineProps<{
        feature: FeatureType
    }>();

    const compData = reactive<{
        featureEnabled?: boolean
    }>({});

    const companySettingsStore = useCompanySettingsStore(initPinia());

    onBeforeMount(async () =>{
        compData.featureEnabled = await companySettingsStore.isFeatureEnabled(props.feature);
    })
</script>

<template>
    <!-- The default slot so we can render something when the feature is enabled -->
    <template v-if="true === compData.featureEnabled">
        <slot>
            <MessageText :displayStyle="DisplayStyle.Danger">
                Feature Enabled: {{ props.feature ?? "(not specified)" }}
            </MessageText>
        </slot>
    </template>

    <!-- A slot to indicate a feature is disabled -->
    <template v-if="false === compData.featureEnabled">
        <slot name="featureDisabled" :feature="props.feature"></slot>
    </template>

</template>